import { render } from "./ServiceErrorModal.vue?vue&type=template&id=6ee50b95"
const script = {}

import "./ServiceErrorModal.vue?vue&type=style&index=0&id=6ee50b95&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__